export default function byteToMiB(byte: number) {
  return byte / 1024 ** 2;
}
